import { render, staticRenderFns } from "./CustomMetadata.vue?vue&type=template&id=a472b2b4&scoped=true"
import script from "./CustomMetadata.vue?vue&type=script&lang=js"
export * from "./CustomMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a472b2b4",
  null
  
)

export default component.exports